import React from 'react';
import { Jumbotron, Button, Form, Input, Col, FormGroup } from 'reactstrap';

class Support extends React.Component {
  render() {
    return (
      <div>
        <Jumbotron>
          <h1 className="display-3">Welcome to support center</h1>
          <p className="lead">Need assistance? We’ll get you the help you need.</p>
          <p className="lead">Just send an email to us at <a href="mailto:cmariotti@executivehrconsulting.com">cmariotti@executivehrconsulting.com</a>.</p>

        </Jumbotron>
      </div>
    );
  }
};

export default Support;


// WEBPACK FOOTER //
// ./src/views/Pages/Support/Support.js